/**
 * Various string-related utils
 */
export class Strings {
    private static emojiRegex = /[\p{Extended_Pictographic}🛰️]/u

    /**
     * Returns 'true' if the given string contains at least one and only emoji characters
     *
     * Strings.isEmoji("⛰\uFE0F") // => true
     * Strings.isEmoji("🇧🇪") // => true
     * Strings.isEmoji("🍕") // => true
     */
    public static isEmoji(string: string): boolean {
        return Strings.emojiRegex.test(string) || Strings.isEmojiFlag(string)
    }

    /**
     * Strings.isEmojiFlag("🇧🇪") // => true
     */
    public static isEmojiFlag(string: string): boolean {
        return /[🇦-🇿]{2}/u.test(string) // flags, see https://stackoverflow.com/questions/53360006/detect-with-regex-if-emoji-is-country-flag
    }

    /**
     * Removes accents from a string
     * @param str
     * @constructor
     *
     * Strings.removeDiacritics("bâtiments") // => "batiments"
     * Strings.removeDiacritics(undefined) // => undefined
     */
    public static removeDiacritics(str?: string): string {
        // See #1729
        if (!str) {
            return str
        }
        return str.normalize("NFD").replace(/\p{Diacritic}/gu, "")
    }

    /**
     * Simplifies a string to increase the chance of a match
     * @param str
     * Strings.simplifyStringForSearch("abc def; ghi 564") // => "abcdefghi564"
     * Strings.simplifyStringForSearch("âbc déf; ghi 564") // => "abcdefghi564"
     * Strings.simplifyStringForSearch(undefined) // => undefined
     */
    public static simplifyStringForSearch(str: string): string {
        return Strings.removeDiacritics(str)
            ?.toLowerCase()
            ?.replace(/[^a-z0-9]/g, "")
    }

    public static randomString(length: number): string {
        let result = ""
        for (let i = 0; i < length; i++) {
            const chr = Math.random().toString(36).substr(2, 3)
            result += chr
        }
        return result
    }
}
